import comp from "./NewTag";
export default comp;
